import { createSlice } from '@reduxjs/toolkit';
import { DASHBOARD } from 'constants/routes';

import * as REQUESTS from '../api/postRequests';
import { setAlert } from './alertSlice';
import { loadUser } from './authSlice';

const initialState = {
  allPosts: null,
  post: null,
  userPosts: null,
  addedPost: null,
  deletedPost: null,
  updatedPost: null,
  likedPost: null,
  unlikedPost: null,
  addedComment: null,
  deletedComment: null,
  ratedPost: null,
  loading: false,
  likeLoading: false,
};

const postSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {
    setAllPosts(state, action) {
      state.allPosts = action.payload;
      state.loading = false;
    },
    setUserPosts(state, action) {
      state.userPosts = action.payload;
      state.loading = false;
    },
    setPost(state, action) {
      state.post = action.payload;
      state.loading = false;
    },
    setLikedPost(state, action) {
      state.likedPost = action.payload;
      state.likeLoading = false;
    },
    setUnlikedPost(state, action) {
      state.unlikedPost = action.payload;
      state.likeLoading = false;
    },
    setAddedPost(state, action) {
      state.post = action.payload;
      state.loading = false;
    },
    setUpdatedPost(state, action) {
      state.updatedPost = action.payload;
      state.loading = false;
    },
    setDeletedPost(state, action) {
      state.deletedPost = action.payload;
      state.loading = false;
    },
    setAddedComment(state, action) {
      state.addedComment = action.payload;
      state.loading = false;
    },
    setDeletedComment(state, action) {
      state.deletedComment = action.payload;
      state.loading = false;
    },
    setRatedPost(state, action) {
      state.ratedPost = action.payload;
      state.loading = false;
    },
    setLikeLoading(state) {
      state.likeLoading = !state.likeLoading;
    },
    setLoading(state) {
      state.loading = !state.loading;
    },
  },
});

export const {
  setAddedPost,
  setDeletedPost,
  setLikeLoading,
  setLoading,
  setPost,
  setUpdatedPost,
  setUserPosts,
  setAllPosts,
  setLikedPost,
  setUnlikedPost,
  setAddedComment,
  setDeletedComment,
  setRatedPost,
} = postSlice.actions;

export default postSlice.reducer;

// thunks

//get all posts
export const getAllPosts = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.getAllPosts();
    const { success, data } = resData;
    if (success) {
      dispatch(setAllPosts(data));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

//get user posts
export const getUserPosts = (id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.getPostsOfUser(id);
    const { success, data } = resData;
    if (success) {
      dispatch(setUserPosts(data));
    }
  } catch (err) {
    dispatch(setLoading());

    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

//get post
export const getPostBySlug = (slug) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.getPostBySlug(slug);
    const { success, data } = resData;
    console.log(data);
    if (success) {
      dispatch(setPost(data));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// add post
export const addPost = (formData, history) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.addPost(formData);
    const { success, data } = resData;
    if (success) {
      dispatch(setAddedPost(data));
      dispatch(loadUser());
      dispatch(setAlert('Post added successfully!', 'success'));
      history.push(DASHBOARD);
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// update post
export const updatePost = (formData, id, history) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.updatePost(formData, id);
    const { success, data } = resData;
    if (success) {
      dispatch(setUpdatedPost(data));
      dispatch(loadUser());
      dispatch(setAlert('Post updated successfully!', 'success'));
      history.push(`/dashboard/posts/${data.slug}`);
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// delete post
export const deletePost = (id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.deletePost(id);
    const { success, data } = resData;
    if (success) {
      dispatch(setDeletedPost(data));
      dispatch(loadUser());
      dispatch(setAlert('Post deleted successfully!', 'success'));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// like post
export const likePost = (post) => async (dispatch) => {
  try {
    dispatch(setLikeLoading());
    const resData = await REQUESTS.likePost(post._id);
    const { success } = resData;
    if (success) {
      dispatch(setLikedPost(post));
      dispatch(setAlert(`You liked ${post.title}`, 'success'));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// unlike post
export const unlikePost = (post) => async (dispatch) => {
  try {
    dispatch(setLikeLoading());
    const resData = await REQUESTS.unlikePost(post._id);
    const { success } = resData;
    if (success) {
      dispatch(setUnlikedPost(post));
      dispatch(setAlert(`You unliked ${post.title}`, 'success'));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// add update
export const addComment = (comment, id) => async (dispatch) => {
  try {
    // dispatch(setLoading());
    const resData = await REQUESTS.addComment(comment, id);
    const { success } = resData;
    if (success) {
      dispatch(setAddedComment(comment));
      dispatch(setAlert('Comment added!', 'success'));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// add update
export const deleteComment = (comment, id) => async (dispatch) => {
  try {
    // dispatch(setLoading());
    const resData = await REQUESTS.deleteComment(id, comment._id);
    const { success } = resData;
    if (success) {
      dispatch(setDeletedComment(comment));
      dispatch(setAlert('Comment deleted!', 'success'));
    }
  } catch (err) {
    // dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// add report
export const addReport = (report, id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.addReport(report, id);
    const { success } = resData;
    if (success) {
      dispatch(setLoading());
      dispatch(
        setAlert('You have successfully reported this post!', 'success')
      );
    }
  } catch (err) {
    dispatch(setLoading());

    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// delete report
export const deleteReport = (report, id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.deleteReport(report, id);
    const { success } = resData;
    if (success) {
      dispatch(setLoading());
      dispatch(setAlert('You have deleted the report!', 'success'));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// add rating
export const addRating = (rating, post) => async (dispatch) => {
  try {
    // dispatch(setLoading());
    const resData = await REQUESTS.addRating(rating, post._id);
    const { success, data } = resData;
    if (success) {
      dispatch(setRatedPost(post));
      dispatch(setAlert('You have successfully rated this post!', 'success'));
    }
  } catch (err) {
    // dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};
